import { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import SyncRoundedIcon from "@mui/icons-material/SyncRounded";

export default function CompletionSaveStatus({ status, retry, name, error }) {
  const [retrying, setRetrying] = useState(false);
  const handleRetry = async () => {
    if (retrying) return;
    setRetrying(true);
    // Keep feedback visible even when an offline retry fails immediately.
    try {
      await Promise.allSettled([Promise.resolve().then(retry), new Promise((resolve) => setTimeout(resolve, 650))]);
    } catch {
      // The sync service retains the failed record for another retry.
    } finally { setRetrying(false); }
  };
  if (retrying) return (
    <button type="button" className="group-completion-retry is-retrying" disabled aria-busy="true"
      aria-label={`Retrying ${name} completion`} title="Retrying save…">
      <SyncRoundedIcon />
    </button>
  );
  if (status === "saving") return <span className="group-completion-saving" role="status"
    aria-label="Saving routine completion" title="Saving completion…"><CircularProgress size={18} /></span>;
  if (status !== "error") return null;
  return <button type="button" className="group-completion-retry" onClick={handleRetry}
    aria-label={`Retry saving ${name} completion`} title={error || "Not synced — retry saving completion"}>
    <SyncRoundedIcon />
  </button>;
}
